<template>
  <v-chip
    :value="value"
    :ripple="!readonly"
    label
    :large="!small"
    :class="`px-4 chip ${short? 'chip__short': ''} ${autoWidth ? 'chip__auto-width' : ''} chip__color${readonly ? '-readonly' : ''} ${center ? 'chip__center' : ''} ${small ? 'chip--small' : ''}`"
    :color="selectedColor"
    active-class="chip__active"
  >
    <template v-if="imageExists">
      <div :class="`chip__img-wrapper ${small ? 'chip__img-wrapper--small' : ''}`">
        <img :src="img" alt="name" :class="`chip__image ${isSpecialImage && (isActive || readonly)? 'chip__image--filter': ''} ${small ? 'chip__image--small' : ''}`" />
      </div>
    </template>
    <template v-else-if="defaultIcon">
      <div :class="`chip__icon-wrapper ${small ? 'chip__icon-wrapper--small' : ''}`">
        <v-icon :color="iconColor" dense small style="margin-right: .75em;">{{ defaultIcon }} </v-icon>
     </div>
    </template>
    <span :class="`chip__text ${readonly ? 'chip__text--readonly' : ''}`">{{ name }}</span>
  </v-chip>
</template>

<script>
export default {
  name: "SimpleChip",
  data() {
    return {
      imageExists: false,
      isActive: false,
    };
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    short:{
      type: Boolean,
      default: false
    },
    autoWidth:{
      type: Boolean,
      default: false
    },
    img: {
      type: String,
    },
    defaultIcon: {
      type: String,
      default: "mdi-folder-multiple",
    },
    selectedItems: {
      type: Array,
      default: () => [],
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    center: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "#E8E7E7",
    },
    readonlyColor: {
      type: String,
      default: "#1b99a7",
    },
  },
  watch: {
    selectedItems: {
      deep: true,
      handler() {
        this.setActiveFlag();
      },
    },
  },
  created() {
    this.setActiveFlag();
    this.setImage();
  },
  computed: {
    isSpecialImage(){
      if(!this.img) return false;
      const specialImages = ['oil-blue.png', 'fragile-blue.png', 'this_side_up-blue.png', 'dangerous-blue.png'];
      return specialImages.some(el => this.img.includes(el));
    },
    selectedColor() {
      if (this.readonly) return this.readonlyColor;
      return this.color;
    },
    iconColor() {
      if (this.readonly) return "#fff";
      return !this.isActive ? "#666666" : "#ffffff";
    },
  },
  methods: {
    setActiveFlag() {
      if (!this.selectedItems) this.isActive = false;
      if (this.selectedItems && this.selectedItems.includes(this.value)) {
        this.isActive = true;
      } else {
        this.isActive = false;
      }
    },
    setImage() {
      if (!this.img) {
        this.imageExists = false;
      } else {
        this.imageExists = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.chip {
  width: 265px;

  &__short{
    width: 140px;
  }

  &__auto-width {
    width: auto !important;
  }

  &--small {
    height: 24px;
  }

  &__text {
    font-family: Arial, sans-serif;
    font-weight: 400;
    font-size: 12px !important;
    line-height: 13.8px !important;
    letter-spacing: 0.1px !important;
    text-transform: uppercase !important;
    color: #666666;
    &--readonly {
      color: #fff;
    }
  }

  &__active {
    background-color: #1b99a7 !important;
    & .chip__text {
      color: #fff !important;
      font-family: Arial, sans-serif;
      font-weight: 400;
      font-size: 12px !important;
      line-height: 13.8px !important;
      letter-spacing: 0.1px !important;
      text-transform: uppercase !important;
    }
  }

  &__color-readonly {
    color: #fff !important;
  }

  &__center {
    text-align: center;
    justify-content: center;
  }

  &__img-wrapper, &__icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 32px;
    margin-right: 0.2em;
    padding-top: .2em;
    padding-bottom:.2em;
    &--small{
      width: 32px;
      height: 18px;
    }
  }

  &__image {
    max-height: 28px;
    max-width: 100px;
    margin-right: 0.75em;

    &--filter{
      filter: brightness(0) invert(1);
    }


    &--small{
      max-height: 18px;
      max-width: 50px;
    }
  }
}
</style>
